import Ajax from '../../ajax.js';

// Multipart POST to the provider's upload host. The provider calls Rails back
// with a signed callback, so the response already is the created record.
const formDriver = {
  createsRecord: true,

  upload(descriptor, file, { progress, success, error, complete, timeout } = {}) {
    const formData = new FormData();
    formData.append('file', file);

    // Every field is server-issued, including the object key placeholders.
    const fields = descriptor.fields || {};
    Object.keys(fields).forEach((name) => {
      formData.append(name, fields[name]);
    });

    const options = {
      data: formData,
      cache: false,
      contentType: false,
      success,
      error,
      progress,
      complete
    };
    // Ajax merges with _.extend, which happily overwrites its 20s default with
    // an undefined value — and setTimeout then reads that as 0ms and aborts the
    // upload on the next tick. Only send the key when it carries a real value.
    if (timeout) options.timeout = timeout;

    return Ajax.post(descriptor.url, options);
  }
};

export default formDriver;
